const  projectsJS = [
    {
       proTitle: "JS projects", 
       projectProps: [
            {
                title: "JS - Image manipulation",
                img: "/img_projects/vanilla-js/project1.png",
                desc: "Vanilla javascript image maniplulation.",
                long_desc: `Small application which, through CSS filters and native contex/canvas functions, allows you to make some changes to the image chosen as input, then giving you the possibility of saving the processed file.`,
                topics: "CSS/HTML, Canvas/CTX, Javascript, ES6",
                location_url: "./web_app/projects/vanillaJS/imageManipulator/index.html",
                source_code: false
            },
            {
                title: "JS - Handeling XML/JSON",
                img: "/img_projects/vanilla-js/project2.png",
                desc: "Get the data from xml/json files.",
                long_desc: `The example shows how to carry out the most common reading, writing and deletion operations on XML and JSON files.`,
                topics: "Javascript, ES6, HTML/CSS",
                location_url: "/web_app/projects/vanillaJS/XML_JSON_Reader/index.html",
                source_code: false
            },
            {
                title: "JS - ToDo app",
                img: "/img_projects/vanilla-js/project3.png",
                desc: "Simple stateful toDo application in pure vanilla javascript code.",
                long_desc: `The code gives the possibility to save data permanently within the localstorage browser, until the user decides to delete them.`,
                topics: "CSS/HTML, Javascript",
                location_url: "/web_app/projects/vanillaJS/toDoApp/index.html",
                source_code: false
            }
            // {
            //     title: "project JS handeling time",
            //     img: "/img_projects/vanilla-js/1.png",
            //     desc: "description project JS 3",
            //     location: "/index.html"
            // }
        ]
    }
]

export {projectsJS}
